import * as React from "react";
import * as _ from "underscore";
import * as moment from "moment";
import Select from "react-select";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { getFileDownloadBaseURL } from "../../../../config";

import WarningTable from "./WarningTable";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

require(`../../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/\
cqm_docmagic_review.scss`);

const humanize = require("underscore.string/humanize");

/* helpers */

const getLatestOfStage = (disclosures, stage) =>
  _.chain(disclosures)
    .where({ stage })
    .sortBy((d: any) => +moment(d.created_at)) // oldest first
    .last()
    .value();

const getLatestDisclosures = disclosures =>
  _.compact([
    getLatestOfStage(disclosures, "LoanEstimate"),
    getLatestOfStage(disclosures, "Redisclosure"),
    getLatestOfStage(disclosures, "ClosingDisclosure"),
  ]);

const initialState = props => {
  const latest = getLatestDisclosures(props.app.disclosures);
  return {
    showingPdfS3Key: latest.length ? latest[0].pdf_s3_key : null,
  };
};

const toTimestamp = disclosure => {
  const m = moment(disclosure.created_at);

  const date = m.format("YYYY-MM-DD");
  const time = m.format("h:mm:ss a");

  return `[${date} / ${time}]`;
};

const getSelectOption = disclosure => ({
  value: disclosure.pdf_s3_key,
  label: `${humanize(`Latest ${disclosure.stage}`)} ${toTimestamp(disclosure)}`,
});

/* component */

interface CQMDocMagicReviewProps {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class CQMDocMagicReview extends React.Component<CQMDocMagicReviewProps, any> {
  constructor(props) {
    super(props);
    this.state = initialState(props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.app.id !== this.props.app.id) {
      this.setState(initialState(nextProps));
    }
  }

  onChange(e) {
    this.setState({
      showingPdfS3Key: e.value,
    });
  }

  render() {
    const { disclosures } = this.props.app;
    const { showingPdfS3Key } = this.state;

    const latest = getLatestDisclosures(disclosures);

    if (!latest.length) {
      return <HurdleView {...this.props}>No disclosures to show</HurdleView>;
    }

    const showing: any = _.where(disclosures, {
      pdf_s3_key: showingPdfS3Key,
    });

    return (
      <HurdleView {...this.props}>
        <div className="cqm-docmagic-review__header">
          <div className="cqm-docmagic-review__select">
            <Select
              placeholder="Select disclosure"
              clearable={false}
              searchable={false}
              value={this.state.showingPdfS3Key}
              options={latest.map(l => getSelectOption(l))}
              onChange={this.onChange.bind(this)}
            />
          </div>
          {showingPdfS3Key && (
            <div className="cqm-docmagic-review__link">
              <a target="_blank" href={getFileDownloadBaseURL(showingPdfS3Key)}>
                <i className="fa fa-file-pdf-o" />
              </a>
            </div>
          )}
        </div>
        <div className="cqm-docmagic-review__container">
          {showing.length && <WarningTable disclosure={showing[0]} />}
        </div>

        <footer className={styles.footer}>
          <button type="button" onClick={() => this.props.onHide()}>
            <i className="fa fa-thumbs-up" /> OK
          </button>
        </footer>
      </HurdleView>
    );
  }
}

export default CQMDocMagicReview;
